import { combineReducers } from 'redux';
import getApiReducer from '../../../../common/utils/getApiReducer';
import { CREATE_IN_PERSON_FOLLOW_UP } from './actions';

export default combineReducers({
  session: getApiReducer(CREATE_IN_PERSON_FOLLOW_UP),
});



// WEBPACK FOOTER //
// ./src/subscription/coaching/in-person-follow-up/redux/reducers.js